import dayjs from 'dayjs';
import isBetween from "dayjs/plugin/isBetween";
dayjs.extend(isBetween); 

// Checks if value is "" or null and returns null if so, otherwise returns value
export function nvl(value) {
    return (value && value !== "") ? value : null;
}


//String Regex
export function StringRegex(){
    return '^[A-Z a-z ñáéíóú]+$';
}

//Number Regex
export function NumberRegex(){
    return '^[0-9]+$';
}

export function DateConstraintFechaIngreso(current){    
    return current > dayjs().endOf('day');
}

export function DateConstraint(current){    
    return current > dayjs('2008-12-31');
}